import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#ed6261' },
    text: {
      secondary: '#3b4056',
    },
  },
  typography: {
    fontFamily: 'inherit',
    fontSize: 'inherit' as any,
    fontWeightRegular: 'inherit' as any,
    fontWeightMedium: 'inherit' as any,
    fontWeightBold: 'inherit' as any,
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '16px',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            height: 0,
          },
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#ed6261' },
    text: {
      secondary: '#d7d8ed',
    },
  },
  typography: {
    fontFamily: 'inherit',
    fontSize: 'inherit' as any,
    fontWeightRegular: 'inherit' as any,
    fontWeightMedium: 'inherit' as any,
    fontWeightBold: 'inherit' as any,
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '16px',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            height: 0,
          },
        },
      },
    },
  },
});
